import axios from 'axios'
import {  castAttributesForSnakeCase } from '../../modules/string_converter'

export const companiesUserActivity = {
  namespaced: true,
  state: {
    data: null,
    loading: true,
    loadError: false,
    errors: null,
  },
  mutations: {
    prepare(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    success(state, payload) {
      state.data = payload.data
      state.loading = false
      state.loadError = false
    },
    failure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    },
  },
  getters: {
    unreadObservationCount(state) {
      if (!state.data) return 0

      return (
        state.data.attributes.unread_reviews_count +
         state.data.attributes.unread_photos_count +
         state.data.attributes.unread_survey_answers_count
      )
    },
    unreadReviewsCount(state) {
      if (!state.data) return 0

      return state.data.attributes.unread_reviews_count
    },
    unreadPhotosCount(state) {
      if (!state.data) return 0

      return state.data.attributes.unread_photos_count
    },
    unreadSurveyAnswersCount(state) {
      if (!state.data) return 0

      return state.data.attributes.unread_survey_answers_count
    },
    originalTagGroupsUnregisteredByStores(state) {
      if (!state.data) return []

      return state.data.attributes.original_tag_groups_unregistered_by_stores
    },
    neverReadPhotos(state) {
      if (!state.data) return false

      return !state.data.attributes.confirmation_photo_list
    },
    neverReadReviews(state) {
      if (!state.data) return false

      return !state.data.attributes.confirmation_review
    },
    neverAnalysisReviews(state) {
      if (!state.data) return false

      return !state.data.attributes.confirmation_review_count
    },
    unreadGmbLocationSyncLogsCount(state) {
      if (!state.data) return 0

      return state.data.attributes.unread_gmb_location_sync_logs_count
    },
    hasServicePattern(state) {
      if (!state.data) return false

      return state.data.attributes.has_service_pattern
    },
    hasFoodMenu(state) {
      if (!state.data) return false

      return state.data.attributes.has_food_menu
    },
    hasPublishingSurvey(state) {
      if (!state.data) return false

      return state.data.attributes.has_publishing_survey
    },
    hasPublishedPosts(state) {
      if (!state.data) return false

      return state.data.attributes.has_published_posts
    },
    hasCompleteMediaLibrary(state) {
      if (!state.data) return false

      return state.data.attributes.has_complete_media_library
    },
    rpaErrorCount(state) {
      if (!state.data) return false

      return state.data.attributes.rpa_error_count
    },
    reviewReplyErrorCount(state) {
      if (!state.data) return false

      return state.data.attributes.review_reply_error_count
    }
  },
  actions: {
    readUserActivity({ commit }, payload) {
      commit('prepare')

      return axios
        .get('/api/companies/' + payload.companyUuid + '/users/activities.json')
        .then(res => {
          commit('success', res.data)
        })
        .catch(err => {
          commit('failure', err)
          console.error(err)
        })
    },
    clearUnreadReviewsCount({ commit }, payload) {
      commit('prepare')

      return axios
        .post('/api/companies/' + payload.companyUuid + '/users/read_reviews.json')
        .then(res => {
          commit('success', res.data)
        })
        .catch(err => {
          commit('failure', err)
          console.error(err)
        })
    },
    clearNeverReadAnalysisReviews({ commit }, companyUuid) {
      commit('prepare')

      return axios
        .put('/api/companies/' + companyUuid + '/users/read_review_counts.json', {
          activity: {
            confirmation_analysis:true
          }
        })
        .then(res => {
          commit('success', res.data)
        })
        .catch(err => {
          commit('failure', err)
          console.error(err)
        })
    },
    clearUnreadPhotosCount({ commit }, payload) {
      commit('prepare')

      return axios
        .post('/api/companies/' + payload.companyUuid + '/users/read_photos.json')
        .then(res => {
          commit('success', res.data)
        })
        .catch(err => {
          commit('failure', err)
          console.error(err)
        })
    },
    clearUnreadSurveyAnswersCount({ commit, rootState }, payload) {
      commit('prepare')

      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/users/read_survey_answers.json', castAttributesForSnakeCase(payload))
        .then(res => {
          commit('success', res.data)
          return true
        })
        .catch(err => {
          commit('failure', err)
          console.error(err)
          return false
        })
    },
    clearUnreadGmbLocationSyncLogsCount({ commit }, payload) {
      commit('prepare')

      return axios
        .post('/api/companies/' + payload.companyUuid + '/users/read_gmb_location_sync_logs.json')
        .then(res => {
          commit('success', res.data)
        })
        .catch(err => {
          commit('failure', err)
          console.error(err)
        })
    },
  }
}
